(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5615],{

/***/ 655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]",
      function () {
        return __webpack_require__(33621);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _chain_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 13 modules
var primitives = __webpack_require__(21666);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(80672);
;// CONCATENATED MODULE: ./public/backgroundSparkle.png
/* harmony default export */ var backgroundSparkle = ({"src":"/_next/static/media/backgroundSparkle.fde240b9.png","height":1500,"width":1500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEX/zg3/zhf8zBn/zxn+zxr/0Bf/zRhcz4BYAAAAB3RSTlMBDBeBajddw2l40AAAAAlwSFlzAAAsSwAALEsBpT2WqQAAACtJREFUeJw1i0EOACAMwgqb/v/JxolcgAYAExkl7UbTqkIkrXHwZe6/ffcDBwAAMW5mn1UAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/home/Footer.tsx
var Footer = __webpack_require__(53593);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(82731);
// EXTERNAL MODULE: ./components/Card.tsx
var Card = __webpack_require__(16050);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
;// CONCATENATED MODULE: ./pages/[chain]/index.tsx















const IndexPage = (param)=>{
    let { ssr  } = param;
    const isSSR = "object" === "undefined";
    const { routePrefix , proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const isMounted = (0,hooks/* useMounted */.s4)();
    const compactToggleNames = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 800px)"
    });
    const [sortByTime, setSortByTime] = (0,react.useState)("1DayVolume");
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const card1Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/76e5fbae85245ef75efc0f23d302cc35.png",
        "https://dl.openseauserdata.com/cache/originImage/files/c87e2dac2803c797f441b5bdd235fde0.png",
        "https://dl.openseauserdata.com/cache/originImage/files/5426e71cfe126de6d66aed9cf74a3b4c.png",
        "https://dl.openseauserdata.com/cache/originImage/files/a261544848cadd8957aa767e68d3aff7.png",
        "https://dl.openseauserdata.com/cache/originImage/files/2261c4e05d3ffca7214fc46948f9b6ad.png"
    ];
    const card2Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/5cdf3c9bead6e3410a385a20568ac877.png",
        "https://dl.openseauserdata.com/cache/originImage/files/33eb53042e74f4b248283a4b59dbb2ea.png",
        "https://dl.openseauserdata.com/cache/originImage/files/b7d4526b85caa1382da13c752f300aab.png",
        "https://dl.openseauserdata.com/cache/originImage/files/9e89b6c758ed01b9c20f60435ff6c0f1.png",
        "https://dl.openseauserdata.com/cache/originImage/files/e9b3b3b33163f2ec90daeb73d1ef748a.png"
    ];
    const card3Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/2243ff14a7f006401f49f27128e71496.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/86fb16b0a7f3abc550dd460211c86be6.png",
        "https://dl.openseauserdata.com/cache/originImage/files/0745252729240748b1da5d00a250f024.png",
        "https://dl.openseauserdata.com/cache/originImage/files/b3abc1636288de97eba0e3a434fd6bb9.png",
        "https://dl.openseauserdata.com/cache/originImage/files/966c33d15495bb2b912bce2382996c8b.png"
    ];
    const card4Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/ae0582399ed49f7e8f59c6e80bf13cda.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/27c94f10f0de590dec0276aba1f501c7.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/9476c1293c5f22d99a3b63454f7efe39.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/2f6deae31c1a5798219454d9f4caa447.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/d8044aa2ae2f9fd1968e7dbd6e22ea73.jpg"
    ];
    const card5Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/98b97d48e55c6bb0e32eb9d6213314a3.gif",
        "https://dl.openseauserdata.com/cache/originImage/files/92ae4a98f82c2248030fdc34ce286fec.gif",
        "https://dl.openseauserdata.com/cache/originImage/files/68c424dcf22d14d2b102442eef52ab62.gif",
        "https://dl.openseauserdata.com/cache/originImage/files/6102ed00b0c04114c62ede9a2353e0be.gif",
        "https://dl.openseauserdata.com/cache/originImage/files/b34dc07acfc9f8f7e36341a3547db34d.gif"
    ];
    const card6Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/4e157de540a07a849001cfdba9d46fd1.gif",
        "https://dl.openseauserdata.com/cache/originImage/files/779c15f5b16dd73626d994ed034cee69.png",
        "https://dl.openseauserdata.com/cache/originImage/files/eff2a1434450d229c490b46a2b22ca4f.png",
        "https://dl.openseauserdata.com/cache/originImage/files/e3c37ec94fc230cf070e5d31bed38fc6.gif",
        "https://dl.openseauserdata.com/cache/originImage/files/a6ced85ccc25d4bb2bf2303f9b4c77b0.png"
    ];
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    let volumeKey = "allTime";
    switch(sortByTime){
        case "1DayVolume":
            volumeKey = "1day";
            break;
        case "7DayVolume":
            volumeKey = "7day";
            break;
        case "30DayVolume":
            volumeKey = "30day";
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    background: "$hunnysPurple",
                    p: 24,
                    height: "100%",
                    width: "100%",
                    position: "relative",
                    "@bp800": {
                        p: "$6"
                    },
                    "&::before": backgroundSparkle
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            mx: "auto",
                            maxWidth: "100%",
                            pt: "$5",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "4rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "The Hunnys Marketplace"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "__Inter_9d0077",
                                    fontSize: "2rem",
                                    letterSpacing: "1px"
                                },
                                children: "Unleash Your Creativity"
                            })
                        ]
                    }),
                    isDisconnected && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            mx: "auto",
                            maxWidth: "100%",
                            pt: "$5",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                as: "h2",
                                css: {
                                    mb: 48
                                },
                                children: "Connect your wallet to begin shopping, or to explore what you already own!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            my: "$6",
                            gap: 65,
                            maxWidth: "100%",
                            justifyContent: "end"
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "end",
                                align: "stretch",
                                css: {
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    gap: 24,
                                    "@bp1300": {
                                        justifyContent: "space-between"
                                    },
                                    "@bp800": {
                                        justifyContent: "space-between"
                                    },
                                    "@bp500": {
                                        justifyContent: "center"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Hunnys",
                                        description: "Unleash your creativity - 10,000 unique, colorful NFTs on Ethereum. Witness the revolutionary color harmony system for yourself that makes each & every Hunny so visually satisfying, and fun to collect. The best place to start to explore The Bunny Kingdom.",
                                        carouselImages: card1Images,
                                        button2Link: "/about/hunnys",
                                        button2Text: "INFO",
                                        button1Link: "/collection/ethereum/0x5dfeb75abae11b138a16583e03a2be17740eaded",
                                        button1Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Hunnys Seasons",
                                        description: "Hunnys Seasons are rewards delivered monthly to Hunnys holders! Every month, a set of 5-7 brand new Seasons NFTs are minted. They introduce new characters & stories within the Hunnys universe. Themes voted on by community, then airdropped for free!",
                                        carouselImages: card2Images,
                                        button2Link: "about/hunnys-seasons",
                                        button2Text: "INFO",
                                        button1Link: "/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b",
                                        button1Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Hunnys Closet Shop",
                                        description: "Welcome to the Hunnys Closet Shop! This is a collection of pieces that will immediately unlock specific traits for use in the Hunnys Closet, coming September 12! Some unlock single items, some unlock dyes, and some unlock full, matching sets of Closet items!",
                                        carouselImages: card6Images,
                                        button2Link: "https://closet.hunnys.io",
                                        button2Text: "CLOSET",
                                        button1Link: "/collection/polygon/0x11bc733e719198e2b3746f6841d2818ca87af6da",
                                        button1Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Hupe Scouts",
                                        description: "The Official Hunnys Community-Owned Derivative Brand. This collection is grown, governed, & maintained by members of the Hunnys community, primarily within Discord. Plus, all creators receive an exclusive Haley the Hupe Scout NFT!",
                                        carouselImages: card3Images,
                                        button2Link: "https://hupe.hunnys.io",
                                        button2Text: "MINT",
                                        button1Link: "/collection/ethereum/0x9fa26d53b63e9fa544675b790ae7d5c24b94bc6e",
                                        button1Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Hunnys OGs",
                                        description: "Hunnys OGs is an exclusive collection of hand-drawn 1/1 avatars created by the artist CryptoStacys. The collection contains the first 100 hand-drawn Hunnys, which inspired the 10k collection, as well as 50 others by gift, commission, and invitation.",
                                        carouselImages: card4Images,
                                        button1Link: "/collection/ethereum/0x64bd44df5590cfe4f0395b05fa0e6f096734bb77",
                                        button1Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Stacys",
                                        description: "The award-winning Stacys collection is a unique and historic example of hand-drawn, 1/1 collectible pixel art NFTs. One of the earliest known women-led NFTs representing women, as well as one of the earliest animated pixel art collections by a female creator.",
                                        carouselImages: card5Images,
                                        button1Link: "/collection/ethereum/0x21ac5f6c96ccb174115b18318e3e340237a55606",
                                        button1Text: "SHOP"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    alignSelf: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(routePrefix, "/collection-rankings"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        css: {
                                            minWidth: 224,
                                            justifyContent: "center",
                                            fontFamily: "Luckiest Guy, cursive",
                                            fontWeight: "normal",
                                            mb: "$2",
                                            fontSize: "28px"
                                        },
                                        size: "large",
                                        children: "VIEW All COLLECTIONS"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _chain_ = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,5864,5535,1943,6485,9774,2888,179], function() { return __webpack_exec__(655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);